import { render, staticRenderFns } from "./BannerManage.vue?vue&type=template&id=3cb69745&"
import script from "./BannerManage.vue?vue&type=script&lang=js&"
export * from "./BannerManage.vue?vue&type=script&lang=js&"
import style0 from "./BannerManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports